// extracted by mini-css-extract-plugin
export default {"nav":"Navbar_nav__5Red5","menu":"Navbar_menu__bU54i","mobileMenu":"Navbar_mobileMenu__L40J-","dropdownMenu":"Navbar_dropdownMenu__MOhKe"};